exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@keyframes spin {\nto {\n    transform: rotate(360deg);\n}\n}\n.coming-soon[data-v-20fa3fe5] {\n  background: #ffffff;\n  min-height: 300px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 24px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  border-radius: 3px;\n}\n.coming-soon i.fal[data-v-20fa3fe5] {\n    font-size: 48px;\n    display: block;\n    animation: spin 5s infinite linear;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-20fa3fe5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/elements/comingSoon.vue
// module id = 551
// module chunks = 0